export const useWindowWidth = () => {
	const { width } = useWindowSize()

	const isMobile = computed(() => width.value <= 768)
	const isTablet = computed(() => width.value > 768 && width.value <= 1200)
	const isDesktop = computed(() => width.value > 1200)
	const isNotMobile = computed(() => width.value > 768)

	// widths from scss variables
	const isMobile_xs = computed(() => width.value <= 374)
	const isMobile_sm = computed(() => width.value <= 468)
	const isMobile_md = computed(() => width.value <= 568)
	const isMobile_lg = computed(() => width.value <= 768)
	const isMobile_xl = computed(() => width.value <= 876)
	const isTablet_sm = computed(() => width.value <= 1100)
	const isTablet_rg = computed(() => width.value <= 1200)
	const isTablet_lg = computed(() => width.value <= 1368)
	const isDesktop_sm = computed(() => width.value <= 1440)
	const isDesktop_md = computed(() => width.value <= 1600)
	const isDesktop_lg = computed(() => width.value > 1600)

	return {
		isMobile,
		isTablet,
		isDesktop,
		isNotMobile,
		isMobile_xs,
		isMobile_sm,
		isMobile_md,
		isMobile_lg,
		isMobile_xl,
		isTablet_sm,
		isTablet_rg,
		isTablet_lg,
		isDesktop_sm,
		isDesktop_md,
		isDesktop_lg,
	}
}
